export default __webpack_public_path__ + "static/media/backgroundcard.3f22c3d5.png";